import { useEffect, useState } from 'react';
import { Homepage } from './routes/Homepage';
import { StartFlow } from './routes/StartFlow';
import { UploadFlow } from './routes/UploadFlow';
import { DraftFlow } from './routes/DraftFlow';
import { EditorFlow } from './routes/EditorFlow';
import { PreflightFlow } from './routes/PreflightFlow';
import { PrintPreview } from './routes/PrintPreview';
import { ProjectsDashboard } from './routes/ProjectsDashboard';
import { OrderFlow } from './routes/OrderFlow';

function getCurrentPath() {
  return window.location.pathname;
}

export default function App() {
  const [path, setPath] = useState(getCurrentPath);

  useEffect(() => {
    const handlePopState = () => setPath(getCurrentPath());
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (path === '/start') return <StartFlow />;
  if (path === '/upload') return <UploadFlow />;
  if (path === '/draft') return <DraftFlow />;
  if (path === '/editor') return <EditorFlow />;
  if (path === '/preflight') return <PreflightFlow />;
  if (path === '/print-preview') return <PrintPreview />;
  if (path === '/projects') return <ProjectsDashboard />;
  if (path === '/order') return <OrderFlow />;

  return <Homepage />;
}
